// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"c3a71a48","1199":"f5f2fe0b","3402":"65fd8607","8609":"f5f2fe0b"}[chunkId] + ".chunk.css";
};